var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1200 685",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 321v340h116A1261 1261 0 0 0 221 659 92 92 0 0 0 285 627 94 94 0 0 0 290 508 92 92 0 0 0 244 480 80 80 0 0 0 283 444 81 81 0 0 0 280 363 86 86 0 0 0 220 324 370 370 0 0 0 165 321zM92 377h46A1540 1540 0 0 1 179 378 107 107 0 0 1 193 379 36 36 0 0 1 219 394 43 43 0 0 1 218 440 42 42 0 0 1 192 454 107 107 0 0 1 176 455 1478 1478 0 0 1 144 456h-52zM92 513h60A414 414 0 0 1 193 514 53 53 0 0 1 223 525 42 42 0 0 1 238 559 40 40 0 0 1 221 594 50 50 0 0 1 196 602 466 466 0 0 1 156 604h-64zM826 321h-103l-61 232 -61 -232h-103v340h64v-268l67 268h66l67 -268v268h64zM433 321v340h-68v-340z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#431FBF",
    d: "M933 180h-117l-57 73h174z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DAA6BD",
    d: "M1002 24h-69v156h69z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFBCA2",
    d: "M1176 180h-174v73h118z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9E37E",
    d: "M1002 253h-69v174h69z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBim);
export default __webpack_public_path__ + "static/media/bim.95575c97f014e80426bc14c4789462a7.svg";
export { ForwardRef as ReactComponent };